import React from "react";

export default function NotFound() {
  return (
    <div className="p-3">
      <h1>404 Not Found</h1>
    </div>
  );
}
